<template>
  <v-row dense align="center">
    <DatetimePicker
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      v-model="model"
      v-if="!$vuetify.theme.dark"
      :label="label"
      :error-messages="errorMessages"
      :disabled-before-now="disabledBeforeNow"
      :disabled-before-today="disabledBeforeToday"
      :removeIcon="removeIcon"
    />
    <DatetimePickerDark
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      v-model="model"
      v-if="$vuetify.theme.dark"
      :label="label"
      :error-messages="errorMessages"
      :disabled-before-now="disabledBeforeNow"
      :disabled-before-today="disabledBeforeToday"
      :removeIcon="removeIcon"
    />
  </v-row>
</template>

<script>
import i18n from "@/i18n";
import DatetimePicker from "@/plugins/datepicker/DatetimePicker";
import DatetimePickerDark from "@/plugins/datepicker/DatetimePickerDark";

export default {
  name: "SearcherDatetime",

  props: {
    value: String,
    label: String,
    type: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    hideIcon: Boolean,
    required: Boolean,
    disabledBeforeNow: Boolean,
    disabledBeforeToday: Boolean,
    removeIcon: Boolean,
  },

  components: {
    DatetimePicker,
    DatetimePickerDark,
  },

  data: () => ({
    model: "",
    errorMessages: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value ? this.value.replaceAll("/", "-") : this.value;
      },
    },
    model: {
      immediate: true, //初始赋值也调用
      handler() {
        this.errorMessages =
          this.required && !this.model
            ? [i18n.t("$validate.messages.trequired")]
            : null;
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
